<template>
    <wizard-layout :id="this.step">
        <template>
            <wizard-box-left>

                <wizard-step :step="this.step" :header_step="this.header_step" :user="this.user"></wizard-step>
                <wizard-header :title="this.title"></wizard-header>

                <div class="row">
                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-3 col-12">
                                <label>Ascensore</label>
                            </div>
                            <div class="col-lg-6 col-12">
                                <div class="row">
                                    <wizard-button-step-4 v-for="elevator in this.elevators"
                                            :key="elevator.value"
                                            :text="elevator.text"
                                            :isActive="selected_elevator === elevator.value"
                                            @onToggle="toggle(elevator.value,'elevator','elevators','selected_elevator')"
                                    >
                                    </wizard-button-step-4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-3 col-12">
                                <label>Balcone/terrazzo</label>
                            </div>
                            <div class="col-lg-6 col-12">
                                <div class="row">
                                    <wizard-button-step-4 v-for="balcony in this.balconies"
                                             :key="balcony.value"
                                             :text="balcony.text"
                                             :isActive="selected_balcony === balcony.value"
                                             @onToggle="toggle(balcony.value,'balcony','balconies','selected_balcony')"
                                    >
                                    </wizard-button-step-4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-3 col-12">
                                <label>Garage</label>
                            </div>
                            <div class="col-lg-6 col-12">
                                <div class="row">
                                    <wizard-button-step-4 v-for="garage in this.garages"
                                              :key="garage.value"
                                             :text="garage.text"
                                             :isActive="selected_garage === garage.value"
                                             @onToggle="toggle(garage.value,'garage','garages','selected_garage')"
                                    >
                                    </wizard-button-step-4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 mb-4">
                        <div class="row">
                            <div class="col-lg-3 col-12">
                                <label>Giardino</label>
                            </div>
                            <div class="col-lg-6 col-12">
                                <div class="row">
                                    <wizard-button-step-4 v-for="garden in this.gardens"
                                                             :key="garden.value"
                                                             :text="garden.text"
                                                             :isActive="selected_garden === garden.value"
                                                             @onToggle="toggle(garden.value,'garden','gardens','selected_garden')"
                                    >
                                    </wizard-button-step-4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <wizard-footer :step="this.step"
                               :display_next_button="display_next_button"
                               :wizard_data="getWizardData"
                               :user="this.user"
                >
                </wizard-footer>

            </wizard-box-left>
            <wizard-box-right :id="this.step">
                <wizard-progress :progress="this.progress" :progress_title="this.progress_title" :progress_description="this.progress_description"></wizard-progress>

            </wizard-box-right>
        </template>
    </wizard-layout>
</template>


<script>

import WizardLayout from "@/Pages/Wizard/Layouts/WizardLayout";
import WizardBoxRight from "@/Pages/Wizard/Layouts/WizardBoxRight";
import WizardBoxLeft from "@/Pages/Wizard/Layouts/WizardBoxLeft";
import WizardStep from "@/Pages/Wizard/Elements/WizardStep";
import WizardHeader from "@/Pages/Wizard/Elements/WizardHeader";
import WizardFooter from "@/Pages/Wizard/Elements/WizardFooter";
import WizardButtonStep2 from "@/Pages/Wizard/Elements/WizardButtonStep2";
import WizardProgress from "@/Pages/Wizard/Elements/WizardProgress";
import Button from "@/Jetstream/Button";
import WizardButtonStep4 from "@/Pages/Wizard/Elements/WizardButtonStep4";
import {redirectWizardSteps} from "@/helpers/helper";

export default {
    props: ['data', 'user'],

    computed: {
        classes() {
            return this.isActive ? 'btn-primary' : 'btn-outline-secondary'
        },

        display_next_button() {
            return this.fieldsAreEmpty()
        },

        getWizardData() {
            return {
                elevator: this.elevator,
                balcony: this.balcony,
                garage: this.garage,
                garden: this.garden,
            }
        }
    },

    data() {
        return {
            step: 4,
            header_step: 5,
            title: "Il tuo immobile dispone di",
            progress: 2,
            progress_title: "Definisci le caratteristiche del tuo immobile.",
            progress_description: "Per ricevere una valutazione accurata del tuo immobile è fondamentale conoscere tutte le sue caratteristiche.",
            selected_elevator: 0,
            elevators: [
                {value: 1, name: true, text: 'Sì'},
                {value: 2, name: false, text: 'No'}
            ],
            elevator: null,
            selected_balcony: 0,
            balconies: [
                {value: 1, name: true, text: 'Sì'},
                {value: 2, name: false, text: 'No'}
            ],
            balcony: null,
            selected_garage: 0,
            garages: [
                {value: 1, name: true, text: 'Sì'},
                {value: 2, name: false, text: 'No'}
            ],
            garage: null,
            selected_garden: 0,
            gardens: [
                {value: 1, name: true, text: 'Sì'},
                {value: 2, name: false, text: 'No'}
            ],
            garden: null
        }
    },

    components: {
        WizardButtonStep4,
        Button,
        WizardProgress,
        WizardButtonStep2, WizardFooter, WizardHeader, WizardStep, WizardBoxLeft, WizardLayout, WizardBoxRight
    },

    methods: {
        isAgency() {
            return (this.user !== null && !(window.location.href.includes('customer')))
        },

        toggle(index, data, array_data, selected_data) {
            var properties = this.$data[array_data].filter(property => {
                return property.value === index;
            })

            this.$data[selected_data] = index
            this.$data[data] = properties[0].name
        },

        fieldsAreEmpty() {
            return (this.balcony !== null && this.garage !== null && this.garden !== null)
        }
    },

    beforeMount() {
        redirectWizardSteps(this.isAgency(),this.step,'test',this.$inertia)

        let current_property = localStorage.getItem('current_property')

        if (current_property != null || current_property != 'undefined') {
            let current_property_parsed = JSON.parse(current_property)

            let property_characteristics = [
                {data: 'elevator', selected_data: 'selected_elevator', array_data: 'elevators', value: current_property_parsed.elevator},
                {data: 'balcony', selected_data: 'selected_balcony', array_data: 'balconies', value: current_property_parsed.balcony},
                {data: 'garage', selected_data: 'selected_garage', array_data: 'garages', value: current_property_parsed.garage},
                {data: 'garden', selected_data: 'selected_garden', array_data: 'gardens', value: current_property_parsed.garden}
            ]

            property_characteristics.forEach(characteristic => {
                let prop_char = this.$data[characteristic.array_data].filter(property => {
                    return property.name == characteristic.value;
                })

                this.toggle(prop_char[0].value, characteristic.data, characteristic.array_data, characteristic.selected_data)
            })
        }
    }
}
</script>
